<template>
  <div>
    <Head title="Delivery Runs" />
    <h1 class="mb-8 text-3xl font-bold">Delivery Runs</h1>
    <div class="flex items-center justify-between mb-6">
      <search-with-date-range v-model="form.search" class="mr-0 w-full max-w-md mr-3"/>
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
    </div>
    <hr />
    <div v-if="form.dateValue && url()" class="bg-white rounded-md shadow overflow-x-auto p-5 mb-5">
      <div class="flex items-center justify-between">
        <a
          class="btn-orange px-3 py-2 text-xs cursor-pointer"
          :href="`/dispatches/delivery-runs/download${url()}`"
          download
          target="__blank"
          title="Download"
        >
          <span>Download</span>
        </a>
      </div>
    </div>
    <ul
      id="tabs-tabFill"
      class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
      role="tablist"
    >
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-home-tabFill"
          href="#tabs-homeFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active" 
          data-bs-toggle="pill" 
          data-bs-target="#tabs-homeFill" 
          role="tab"
          aria-controls="tabs-homeFill"
          aria-selected="true"
        >
          Open
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center"
        role="presentation"
      >
        <a 
          id="tabs-profile-tabFill"
          href="#tabs-profileFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-profileFill"
          role="tab"
          aria-controls="tabs-profileFill"
          aria-selected="false"
        >
          Closed
        </a>
      </li>
    </ul>
    <div id="tabs-tabContentFill" class="tab-content">
      <div id="tabs-homeFill" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Type</th>
              <th class="pb-3 pt-3 px-3">DR Number</th>
              <th class="pb-3 pt-3 px-3">Delivery Assistant</th>
              <th class="pb-3 pt-3 px-3">Vehicle number plate</th>
              <th class="pb-3 pt-3 px-3">Volume</th>
              <th class="pb-3 pt-3 px-3">Status</th>
              <th class="pb-3 pt-3 px-3">Created By</th>
              <th class="pb-3 pt-3 px-3 text-end" />
            </tr>
            <tr v-for="list in pending.data" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <a class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${list.id}/packed/orders`" title="">
                  {{ list.date }}
                </a>
              </td>
              <td class="border-t">
                <a class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${list.id}/packed/orders`" title="">
                  {{ list.comment }}
                </a>
              </td>
              <td class="border-t">
                <a class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${list.id}/packed/orders`" title="">
                  {{ list.number }}
                </a>
              </td>
              <td class="border-t">
                <a class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${list.id}/packed/orders`" title="">
                  {{ list.user }}
                </a>
              </td>
              <td class="border-t">
                <a class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${list.id}/orders`" title="">
                  {{ list.plate_number }}
                </a>
              </td>
              <td class="border-t">
                <a class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${list.id}/packed/orders`" title="">
                  {{ list.volume }}
                </a>
              </td>
              <td class="border-t">
                <a class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${list.id}/packed/orders`" title="">
                  {{ list.status }}
                </a>
              </td>
              <td class="border-t">
                <a class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${list.id}/packed/orders`" title="">
                  {{ list.created_by }}
                </a>
              </td>
              <td class="w-px border-t">
                <a :href="`/dispatches/delivery-runs/${list.id}/packed/orders`" class="flex items-center justify-end pr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </a>
              </td>
            </tr>
            <tr v-if="pending.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="7">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="pending.links" />
      </div>
      <div id="tabs-profileFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Type</th>
              <th class="pb-3 pt-3 px-3">DR Number</th>
              <th class="pb-3 pt-3 px-3">Delivery Assistant</th>
              <th class="pb-3 pt-3 px-3">Vehicle number plate</th>
              <th class="pb-3 pt-3 px-3">Volume</th>
              <th class="pb-3 pt-3 px-3">Status</th>
              <th class="pb-3 pt-3 px-3">Created By</th>
              <th class="pb-3 pt-3 px-3 text-end" />
            </tr>
            <tr v-for="listp in delivery_runs.data" :key="listp.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${listp.id}/orders`" title="">
                  {{ listp.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${listp.id}/orders`" title="">
                  {{ listp.comment }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${listp.id}/orders`" title="">
                  {{ listp.number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${listp.id}/orders`" title="">
                  {{ listp.user }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${listp.id}/orders`" title="">
                  {{ listp.plate_number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${listp.id}/orders`" title="">
                  {{ listp.volume }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${listp.id}/orders`" title="">
                  {{ listp.status }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/delivery-runs/${listp.id}/orders`" title="">
                  {{ listp.created_by }}
                </Link>
              </td>
              <td class="w-px border-t">
                <a :href="`/dispatches/delivery-runs/${listp.id}/orders`" class="flex items-center justify-end pr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </a>
              </td>
            </tr>
            <tr v-if="delivery_runs.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="7">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="delivery_runs.links" />
      </div>
    </div>
  </div>
</template>
      
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import Pagination from '@/Shared/Pagination'
      
export default {
  components: {
    Head,
    Link,
    SearchWithDateRange,
    DateRange,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    delivery_runs: Object,
    pending: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        dateValue: this.filters.dateValue,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/dispatches/delivery-runs', pickBy(this.form), { 
          preserveState: true,
          preserveScroll: true,
          replace: true 
        })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    url() {
      let query = ''
      if (this.form.search) {
        query += `search=${this.form.search}`
      }
      if (this.form.dateValue) {
        if (query) {
          query += '&'
        }
        query += `dateValue=${this.form.dateValue}`
      }
      if (query) {
        query = `?${query}`
      }
      return query
    },
  },
}
</script>
      